/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CategoryDeleteSubCategoryResponse } from './CategoryDeleteSubCategoryResponse';

export type CategoryDeleteSubCategoryResponseApiRespoonse = {
    data?: CategoryDeleteSubCategoryResponse;
    status?: CategoryDeleteSubCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CategoryDeleteSubCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

